// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3ddFh","bigColWidth":"Table_bigColWidth__R8zD-","biggerColWidth":"Table_biggerColWidth__2SvnK","row":"Table_row__18R3D","col":"Table_col__3Mcr0"};